// Account/session helpers — single source of truth for the `myAccountType` login signal

const ACCOUNT_TYPE_COOKIE = 'myAccountType';
const POWER_ACCOUNT_TYPE = 'power';

// Reads a cookie value by name on the client; returns undefined on the server or when absent
export function getCookieValue(name: string): string | undefined {
  if (typeof document === 'undefined') return;

  const cookies = document.cookie.split('; ');
  const cookie = cookies.find((c) => c.startsWith(name + '='));

  return cookie ? decodeURIComponent(cookie.split('=')[1]) : undefined;
}

// Returns true when the `myAccountType` cookie marks the current session as a logged-in power user
export function getIsAccountLoggedIn(): boolean {
  return getCookieValue(ACCOUNT_TYPE_COOKIE) === POWER_ACCOUNT_TYPE;
}
